// src/data/dummyStudents.js
export const dummyStudents = [
  {
    id: 1,
    name: "Juan Dela Cruz",
    grade: "Grade 10",
    section: "A",
    balance: 5000,
    payments: [
      { date: "2024-01-15", amount: 2000 },
      { date: "2024-02-10", amount: 1500 }
    ]
  },
  {
    id: 2,
    name: "Maria Santos",
    grade: "Grade 12",
    section: "B",
    balance: 3000,
    payments: [
      { date: "2024-01-20", amount: 1000 },
      { date: "2024-02-15", amount: 1000 }
    ]
  },
  {
    id: 3,
    name: "Pedro Reyes",
    grade: "Grade 11",
    section: "C",
    balance: 4000,
    payments: [
      { date: "2024-01-25", amount: 2000 },
      { date: "2024-02-20", amount: 1000 }
    ]
  }
];